<template>
  <v-dialog v-model="dialog" max-width="900" scrollable @click:outside="$emit('update:activated', false)">
    <v-card>
      <v-card-title class="headline">Selecionar Movimentação da Blindada:</v-card-title>
      <v-row align="center" no-gutters>
        <v-col cols="12">
          <v-text-field
            v-show="!loading"
            v-model="search"
            append-icon="mdi-magnify"
            class="mx-10 py-4"
            label="Procurar"
            hide-details
            single-line
          />
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="incluirDataAtualizarAte ? headersComAtualizarAte : headersSemAtualizarAte"
            :items="items"
            :items-per-page="itemsPerPage"
            :search.sync="search"
            :page.sync="currentPage"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            no-data-text="Nenhuma movimentação da blindada disponível"
            :mobile-breakpoint="0"
          >
            <template v-slot:item="row">
              <tr @click="selecionarItem(row.item)">
                <td class="button cursor-pointer">
                  {{ row.item.id }}
                </td>
                <td class="button cursor-pointer">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="text-truncate" v-bind="attrs" v-on="on">
                        {{ row.item.titulo }}
                      </div>
                    </template>
                    <span>{{ row.item.titulo }}</span>
                  </v-tooltip>
                </td>
                <td class="button cursor-pointer">
                  {{ row.item.ano_mes_corte_ultimo_ciclo | formatToMonth }}
                </td>
                <td v-if="incluirDataAtualizarAte" class="button cursor-pointer">
                  {{ row.item.atualizar_ate | formatToMonth }}
                </td>
                <td class="button cursor-pointer">
                  {{ row.item.data_processamento | parseToDateTimeBR }}
                </td>
              </tr>
            </template>
            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" @click="getBasesValidadas()">mdi-refresh</v-icon>
                </template>
                <span>Clique aqui para recarregar as movimentações da blindada</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import MovimentacaoBlindadaService from '@/services/MovimentacaoBlindadaService';

  export default {
    props: {
      activated: {
        type: Boolean,
        required: true
      },
      incluirDataAtualizarAte: {
        type: Boolean,
        default: false,
        required: false
      }
    },

    emits: ['update:activated', 'selected'],

    data: () => ({
      currentPage: 1,
      itemsPerPage: 5,
      search: undefined,
      items: [],
      loading: false,
      headersSemAtualizarAte: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Título',
          value: 'titulo'
        },
        {
          text: 'Data de Corte do Último Ciclo',
          value: 'ano_mes_corte_ultimo_ciclo'
        },
        {
          text: 'Executado',
          value: 'data_processamento'
        }
      ],
      headersComAtualizarAte: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Título',
          value: 'titulo'
        },
        {
          text: 'Data de Corte do Último Ciclo',
          value: 'ano_mes_corte_ultimo_ciclo'
        },
        {
          text: 'Atualizar Até',
          value: 'atualizar_ate'
        },
        {
          text: 'Executado',
          value: 'data_processamento'
        }
      ]
    }),

    computed: {
      dialog() {
        return this.activated;
      }
    },

    created() {
      this.getBasesValidadas();
    },

    methods: {
      getBasesValidadas() {
        this.loading = true;

        MovimentacaoBlindadaService.getByStatus('SUCESSO')
          .then((response) => (this.items = response.data.data))
          .catch(() => this.$toast.error('Erro ao recuperar movimentações da blindada.', '', { position: 'topRight' }))
          .finally(() => (this.loading = false));
      },

      selecionarItem(item) {
        const data = {
          id: item.id,
          titulo: item.titulo,
          data_base: this.getOnlyDateIgnoringTimestamp(item.ano_mes_corte_ultimo_ciclo),
          atualizar_ate: this.getOnlyDateIgnoringTimestamp(item.atualizar_ate)
        };

        this.$emit('selected', data);

        setTimeout(() => {
          this.search = '';
        }, 500);
      },

      getOnlyDateIgnoringTimestamp(date) {
        if (date && date.length > 10) date = date.substr(0, 10);

        return date;
      }
    },

    watch: {
      search() {
        this.currentPage = 1;
      }
    }
  };
</script>

<style>
  .b-valid-label {
    color: #e5502c;
    font-weight: 400;
  }
</style>
